import { TABLE_COL_WIDTH } from '../../constants/table';

export const getCellStyle = (position?: number) => {
  if (position === undefined) {
    return {};
  }

  const x = -1 * position * TABLE_COL_WIDTH;

  return { transform: `translate3D(${x}px, 0, 0)` };
};
